import { render } from "./DissolutionReportTableAdd.vue?vue&type=template&id=08d0c983&ts=true"
import script from "./DissolutionReportTableAdd.vue?vue&type=script&lang=ts"
export * from "./DissolutionReportTableAdd.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__